/**
 * Save only fields changed since the editor opened. Unchanged draft values
 * may be stale after a peer edit; sending them would undo that peer's work.
 * Collaborative bodies already flow through their Y.XmlFragment binding.
 */
export function noteEditUpdates(baseline, draft, { collab = false, updated } = {}) {
  const updates = { updated };
  for (const field of collab ? ['title'] : ['title', 'content']) {
    const value = String(draft[field] ?? baseline?.[field] ?? '');
    if (value !== String(baseline?.[field] ?? '')) updates[field] = value;
  }
  return updates;
}
